export const initialValuesSettings = {
  payment_term: "",
};
